import { ArrowBack, BurgerIcon } from 'assets/icons';
import classNames from 'classnames';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import useMediaQuery from 'hooks/useMediaQuery';
import { SIDEBAR_OPEN_LOCALSTORAGE_NAME } from 'layout/Aside/constants';
import { useNavigationHistory } from 'navigationProvider';
import { FC } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { profileActions } from 'reduxStore/reducers/ProfileSlice';
import { getProfileState } from 'reduxStore/reducers/ProfileSlice/selectors/getProfileState';
import { logoutHandler } from 'utils/helpers';
import { IS_MEDIUM_DEVICE, IS_SMALL_DEVICE } from 'utils/settings';
import { PageWrapperProps } from './types';
import { Button } from '../Button';
import { useAuth } from 'react-oidc-context';
import { useQuery } from 'react-query';
import { AgentService } from 'services/AgentService';

export const PageWrapper: FC<PageWrapperProps> = ({
  title,
  children,
  isGoBack = true,
  withMark = false,
  scrollDivRef,
  isBankManager,
}) => {
  const navigate = useNavigate();
  const { history, removeLastRoute } = useNavigationHistory();
  const location = useLocation();
  const isSmall = useMediaQuery(IS_SMALL_DEVICE);
  const isMedium = useMediaQuery(IS_MEDIUM_DEVICE);
  const dispatch = useAppDispatch();
  const { isSidebarOpen } = useAppSelector(getProfileState);
  const oidcAuth = useAuth();

  const handleToggleOpenSidebar = (): void => {
    if (isSidebarOpen) {
      localStorage.removeItem(SIDEBAR_OPEN_LOCALSTORAGE_NAME);
    } else {
      localStorage.setItem(SIDEBAR_OPEN_LOCALSTORAGE_NAME, 'true');
    }
    dispatch(profileActions.toggleSidebar(!isSidebarOpen));
  };

  const { remove } = useQuery(['getClientOrder'], () => AgentService.getClientOrder(''), {
    enabled: false,
  });

  const handleGOBack = () => {
    if (history.length <= 1) {
      return;
    }
    navigate(-1);
    removeLastRoute();
    removeLastRoute();
  };

  return (
    <div ref={scrollDivRef}>
      <header className="mb-5 flex items-center justify-between">
        <div className="flex w-full items-center justify-between">
          <div>
            {!isMedium ? (
              isGoBack &&
              (history.length > 1 ? (
                <ArrowBack
                  className={classNames('mr-5 -mt-2 h-5 w-5 cursor-pointer', {
                    '!cursor-not-allowed fill-text-50': history.length <= 1,
                  })}
                  onClick={handleGOBack}
                />
              ) : (
                <></>
              ))
            ) : location.pathname.split('/').length < 4 ||
              location.pathname.split('/')[2] === 'final-step' ? (
              <BurgerIcon
                className="mr-5 h-5 w-5 cursor-pointer"
                onClick={handleToggleOpenSidebar}
              />
            ) : (
              <ArrowBack
                className={classNames('mr-5 h-5 w-5', {
                  '!cursor-not-allowed': history.length <= 1,
                })}
                onClick={() => navigate(-1)}
              />
            )}
            <span className="title2-medium sm:title2-bold lg:large-title2-bold mt-1">
              {title}
              {withMark && <span className="ml-1 text-red">!</span>}
            </span>
          </div>
          {isBankManager && (
            <div>
              <Link to="/client/orders/all/create">
                <Button className="callout-bold h-10 py-0 !text-white" onClick={() => remove()}>
                  СОЗДАТЬ ЗАЯВКУ
                </Button>
              </Link>
            </div>
          )}
        </div>
        {isSmall && location.pathname === '/profile' && (
          <div className="flex items-center">
            <button className="callout-medium text-right" onClick={() => logoutHandler(oidcAuth)}>
              ВЫЙТИ
            </button>
          </div>
        )}
      </header>
      <section>{children}</section>
    </div>
  );
};
